
const apiConfig = {
    // Local
    // apiUrl: 'https://localhost:7199/api/',
    // Live
    //apiUrl: 'https://mga-api.off-ease.com/api/',
    // TEST    
    apiUrl: 'https://ie-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

